import { CSSProperties } from 'react';
import cn from 'bem-cn';

import { SkeletonProps } from './Skeleton.types';
import './Skeleton.scss';

const b = cn('skeleton');

export const Skeleton = (props: SkeletonProps) => {
    const { width, height, className, style, variant = 'text' } = props;
    const skeletonStyle: CSSProperties = { ...style };

    if (width !== undefined) {
        skeletonStyle.width = typeof width === 'number' ? `${width}px` : width;
    }

    if (height !== undefined) {
        skeletonStyle.height = typeof height === 'number' ? `${height}px` : height;
    }

    if (variant === 'text' && height === undefined) {
        skeletonStyle.height = '1em';
    }

    return <span className={b({ variant }).mix(className)} style={skeletonStyle} />;
};
